import React, { useState } from "react";
import ProfileSection from "../../components/Employee/Profile/ProfileSection";
import ProfileField from "../../components/Employee/Profile/ProfileField";

export default function ProfileForm({ initialData, onSubmit }) {
  const [profile, setProfile] = useState(initialData || {});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProfile((p) => ({ ...p, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmit) onSubmit(profile);
  };

  return (
    <form className="profile-form" onSubmit={handleSubmit}>
      <ProfileSection title="Personal Information">
        <ProfileField label="Given Name">
          <input
            type="text"
            name="firstName"
            value={profile.firstName}
            onChange={handleChange}
          />
        </ProfileField>

        <ProfileField label="Surname">
          <input
            type="text"
            name="lastName"
            value={profile.lastName}
            onChange={handleChange}
          />
        </ProfileField>

        <ProfileField label="Middle Name">
          <input
            type="text"
            name="middleName"
            value={profile.middleName}
            onChange={handleChange}
          />
        </ProfileField>

        <ProfileField label="Gender">
          <select
            name="gender"
            value={profile.gender}
            onChange={handleChange}
          >
            <option>Male</option>
            <option>Female</option>
            <option>Other</option>
          </select>
        </ProfileField>

        <ProfileField label="Date of Birth">
          <input
            type="date"
            name="birthDate"
            value={profile.birthDate}
            onChange={handleChange}
          />
        </ProfileField>

        <ProfileField label="Address">
          <input
            type="text"
            name="address"
            value={profile.address}
            onChange={handleChange}
          />
        </ProfileField>
      </ProfileSection>

      <ProfileSection title="Contact">
        <ProfileField label="Email">
          <input
            type="email"
            name="email"
            value={profile.email}
            onChange={handleChange}
          />
        </ProfileField>

        <ProfileField label="Mobile Number">
          <input
            type="text"
            name="mobile"
            value={profile.mobile}
            onChange={handleChange}
          />
        </ProfileField>

        <ProfileField label="Github">
          <input
            type="text"
            name="github"
            value={profile.github}
            onChange={handleChange}
          />
        </ProfileField>
      </ProfileSection>

      <ProfileSection title="Benefits Reference Number">
        <ProfileField label="PhilHealth">
          <input
            type="text"
            name="philHealth"
            value={profile.philHealth}
            onChange={handleChange}
          />
        </ProfileField>

        <ProfileField label="SSS">
          <input
            type="text"
            name="sss"
            value={profile.sss}
            onChange={handleChange}
          />
        </ProfileField>

        <ProfileField label="Pag-Ibig">
          <input
            type="text"
            name="pagIbig"
            value={profile.pagIbig}
            onChange={handleChange}
          />
        </ProfileField>
      </ProfileSection>

      <div className="form-actions">
        <button type="submit" className="save-btn">
          Save Changes
        </button>
      </div>
    </form>
  );
}
